const wrapBestUsed = document.querySelector(".embla.best-used");

const setupDotBtnsBestUsed = (dotsArray, embla) => {
  dotsArray.forEach((dotNode, i) => {
    dotNode.addEventListener("click", () => embla.scrollTo(i), false);
  });
};

const generateDotBtnsBestUsed = (dots, embla) => {
  const template = document.getElementById(
    "embla-dot-template-best_used"
  ).innerHTML;
  dots.innerHTML = embla.scrollSnapList().reduce((acc) => acc + template, "");
  return [].slice.call(dots.querySelectorAll(".embla__dot.best_used__dot"));
};

const selectDotBtnBestUsed = (dotsArray, embla) => () => {
  const previous = embla.previousScrollSnap();
  const selected = embla.selectedScrollSnap();
  dotsArray[previous].classList.remove("is-selected");
  dotsArray[selected].classList.add("is-selected");
};

const viewPortBestUsed = wrapBestUsed.querySelector(
  ".embla__viewport.best-used__viewport"
);
const dotsBestUsed = document.querySelector(".embla__dots.best_used__dots");
const emblaBestUsed = EmblaCarousel(viewPortBestUsed, {
  loop: false,
  skipSnaps: false,
  align: "start",
  containScroll: "trimSnaps",
  breakpoints: { "(min-width: 991px)": { active: false, align: "center" } },
});
const dotsArrayBestUsed = generateDotBtnsBestUsed(dotsBestUsed, emblaBestUsed);
const setSelectedDotBtnBestUsed = selectDotBtnBestUsed(
  dotsArrayBestUsed,
  emblaBestUsed
);

setupDotBtnsBestUsed(dotsArrayBestUsed, emblaBestUsed);

emblaBestUsed.on("select", setSelectedDotBtnBestUsed);
emblaBestUsed.on("init", setSelectedDotBtnBestUsed);
